var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlacementCareerSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_18",
    "data-name": "Group 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 80.009,
    viewBox: "0 0 85 80.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e68242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd4633"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 85,
    height: 80.009,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M111.877,91.716a14.357,14.357,0,0,0-.885,4.253A24.052,24.052,0,0,1,86.191,74.8c-2.068-18.166,16.43-31.808,33.246-24.565a23.951,23.951,0,0,1,11.488,33.163c-.3.558-1.3,2.542-1.91,2.451-.812-.121-2.364-1.447-3.5-1.3-.262-.206-.114-.191-.028-.39.224-.514.967-1.288,1.3-1.888,10.364-18.461-10.267-37.841-27.583-26.7a19.747,19.747,0,0,0,.816,33.562c1.675.972,5.642,2.583,7.515,2.583Z",
    transform: "translate(-65.671 -36.831)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M150.434,143.55a11.148,11.148,0,0,1,11.736,7.122c1.414,3.843.152,5.069-3.323,6.428a19.14,19.14,0,0,1-13.912,0c-3.687-1.406-4.779-2.648-3.277-6.56a11.278,11.278,0,0,1,8.776-6.991",
    transform: "translate(-107.634 -109.52)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M14.27,249.075a3.471,3.471,0,0,1,2.159.238,52.224,52.224,0,0,1,4.088,4.061,2.825,2.825,0,0,1,.151,3.161L8.175,269.022c-4.88,3.545-11.131-2.493-6.618-7.858,3.279-3.9,7.859-7.371,11.25-11.249a3.232,3.232,0,0,1,1.462-.84",
    transform: "translate(0 -190.074)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M285.054,159.444a27.317,27.317,0,0,0,2.39-9.92c5.615-4.1,14.468.008,15.131,6.842.229,2.362-2.387,3.4-4.272,4.017a17.094,17.094,0,0,1-13.25-.94",
    transform: "translate(-217.59 -112.889)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M29.94,149.451c.4.593.135,1.341.225,1.991a26.55,26.55,0,0,0,2.3,8.06,17.043,17.043,0,0,1-13.378.892c-3.563-1.228-5.067-2.279-3.537-6.2a9.892,9.892,0,0,1,14.39-4.742",
    transform: "translate(-11.415 -112.946)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M170.052,94.233c5.725-.674,8.038,7.6,2.584,9.851-7.326,3.016-10.225-8.951-2.584-9.851",
    transform: "translate(-126.367 -71.901)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M40.295,103.011c7.125-1.2,7.511,8.87,1.329,9.124-5.8.239-6.332-8.281-1.329-9.124",
    transform: "translate(-28.149 -78.556)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M302.1,103.036c6.281-1.066,7.688,7.46,2.357,8.912-6.4,1.743-8.035-7.948-2.357-8.912",
    transform: "translate(-227.954 -78.58)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M79.876,215.452l4.5,4.666-6.624,6.491-4.519-4.518Z",
    transform: "translate(-55.903 -164.461)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M183.785,0c.534-.048.893.468.955.928a30.426,30.426,0,0,1-.021,4.78.884.884,0,0,1-1.768.02,34.384,34.384,0,0,1,.012-4.965A1.058,1.058,0,0,1,183.785,0",
    transform: "translate(-139.588 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M249.571,20a1.158,1.158,0,0,1,1.138.22,1.008,1.008,0,0,1,.08,1c-.074.275-2.157,3.874-2.4,4.159-.829.978-1.982.194-1.515-.984.572-.6,2.2-4.218,2.695-4.392",
    transform: "translate(-188.366 -15.22)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M111.494,20.251c.428,1.3,2.145,3.174,2.448,4.382.292,1.164-.762,1.688-1.52.8a33.937,33.937,0,0,1-2.4-4.16c-.311-1.185.488-1.547,1.469-1.021",
    transform: "translate(-83.933 -15.279)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M208.119,206.768c11.717-1.408,17.106,13.716,7.464,19.865-8.765,5.591-19.44-3.105-16.109-12.743a11.1,11.1,0,0,1,8.645-7.122m4.38,6.584a1.344,1.344,0,0,0-.9.444c-.592.564-2.907,4.434-3.179,4.434-.956-2.122-3.918-1.366-2.724.955a29.367,29.367,0,0,0,2.283,2.322,1.657,1.657,0,0,0,1.863-.433l4.022-5.727a1.473,1.473,0,0,0-1.37-2",
    transform: "translate(-151.788 -157.762)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacementCareerSupport);
export default __webpack_public_path__ + "static/media/placement_career_support.a86a4b3b2fe769b1c2d1ba630feb2c2b.svg";
export { ForwardRef as ReactComponent };